import { render, staticRenderFns } from "./OnlineStructureMaster.vue?vue&type=template&id=3f56f219&"
import script from "./OnlineStructureMaster.vue?vue&type=script&lang=js&"
export * from "./OnlineStructureMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnlineStructureMaster.vue"
export default component.exports